import React, { useContext } from 'react';
import proptypes from 'prop-types';
import { Button, Link } from '@one-thd/sui-atomic-components';
import { StorePodContext } from '../StorePod.context';
import { StorePodLoader } from './StorePodLoader';

const { oneOf, string, shape } = proptypes;

export const StorePodLink = ({
  type = 'store', visualStyle = 'link', featureData = null, variant = null, trackingParam = ''
}) => {
  const { isDesignStore, loading, store } = useContext(StorePodContext);

  const { address, storeDetailsPageLink, storeId } = store;
  const { city, postalCode, state, street } = address || {};
  const addressFormatted = `${street}, ${city}, ${state} ${postalCode}`;

  const linkMap = {
    directions: {
      href: `https://www.bing.com/mapspreview?where1=${addressFormatted}&amp;sty=c`,
      text: 'Directions'
    },
    localAd: {
      href: `/c/localad?StoreRef=${storeId}`,
      text: 'Local Ad'
    },
    rentals: {
      href: `${storeDetailsPageLink}/rentals`,
      text: 'Available Rentals',
    },
    services: {
      href: `${storeDetailsPageLink}/services`,
      text: 'Available Services',
    },
    store: {
      href: storeDetailsPageLink,
      text: isDesignStore ? 'Learn More' : 'Store Details'
    }
  };
  if (type === 'feature' && featureData) {
    linkMap.feature = {
      href: `${storeDetailsPageLink}${featureData.link}${trackingParam}`,
      text: `View ${featureData.title}`
    };
  }
  const { href, text } = linkMap[type];

  const handleButtonClick = () => {
    window.location.href = href;
  };

  const isText = visualStyle === 'link';

  if (loading) {
    return (
      <div
        data-testid="store-pod-link-loader"
        style={{ width: isText ? '5rem' : '100%' }}
        data-component="StorePodLinkLoader"
      >
        <StorePodLoader height={isText ? '2.2rem' : '4.35rem'} />
      </div>
    );
  }

  return (
    <div className="sui-grid-cols-3" data-component="StorePodLink">
      {!isText && (
        <Button
          data-testid="store-pod-link__button"
          fullWidth
          href={href}
          onClick={handleButtonClick}
          tag="a"
          variant={variant}
        >
          <span>{text}</span>
        </Button>
      )}
      {isText && (
        <Link
          data-testid="store-pod-link__button"
          height="tight"
          href={href}
        >
          {text}
        </Link>
      )}
    </div>
  );
};

StorePodLink.propTypes = {
  type: oneOf(['directions', 'localAd', 'store', 'services', 'rentals', 'feature']),
  visualStyle: oneOf(['button', 'link']),
  featureData: shape({
    title: string,
    link: string
  }),
  variant: string,
  trackingParam: string
};

StorePodLink.displayName = 'StorePodLink';
